import { Box, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TitleComponent from "../../components/widgets/titleComponent";
import SalaryIcon from '.././../assets/icons/salary.svg';
import TimeIcon from '.././../assets/icons/time.svg';
import WorkLifeIcon from '.././../assets/icons/work-life.svg';
import WorkPlaceIcon from '.././../assets/icons/work-place.svg';

const Perks = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    mt: {xs: 5, md: 10}
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >  
                    <TitleComponent 
                        title={t('careers.perks.title')}
                        description={t('careers.perks.description')}
                    />

                    <Grid
                        direction='row'
                        justifyContent='start'
                        alignItems='center'
                        container
                        width='100%'
                        spacing={{xs: 3, md: 10}}
                    >
                        <Grid size={{xs: 12, md: 6}}>
                            <PerksDetails 
                                icon={TimeIcon}
                                title={t('careers.perks.perk1.title')}
                                description={t('careers.perks.perk1.description')}
                            />
                        </Grid>
                        
                        <Grid size={{xs: 12, md: 6}}>
                            <PerksDetails 
                                icon={WorkPlaceIcon}
                                title={t('careers.perks.perk2.title')}
                                description={t('careers.perks.perk2.description')}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 6}}>
                            <PerksDetails 
                                icon={WorkLifeIcon}
                                title={t('careers.perks.perk3.title')}
                                description={t('careers.perks.perk3.description')}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 6}}>
                            <PerksDetails 
                                icon={SalaryIcon}
                                title={t('careers.perks.perk4.title')}
                                description={t('careers.perks.perk4.description')}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default Perks;

const PerksDetails = ({
    icon,
    title,
    description
}) => {
    const theme = useTheme();

    return (
        <>
            <Stack
                direction='row'
                justifyContent='start'
                alignItems='start'
                spacing={{xs: 2, md: 4}}
                data-aos="slide-up"
            >
                <Box
                    sx={{
                        width: 100
                    }}
                >
                    <img 
                        src={icon}
                        alt={title} 
                        width='100%'
                    />
                </Box>

                <Stack
                    direction='column'
                    justifyContent='start'
                    alignItems='start'
                    spacing={2}
                >
                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 14, md: 24}}
                        textAlign='left'
                        color={theme.palette.text.primary}
                        lineHeight={1.5}
                    >
                        {title}
                    </Typography>

                    <Typography
                        fontWeight={500}
                        fontSize={{xs: 12, md: 12, lg: 14}}
                        textAlign="justify"
                        lineHeight={1.5}
                        color={theme.palette.text.secondary}
                    >
                        {description}
                    </Typography>
                </Stack>
            </Stack>
        </>
    );
}